import { useMutation } from 'react-query'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { delContactGroup } from '../../../api/DELETE/delContactGroup'
import { createContactGroup } from '../../../api/POST/contactGroup'
import { putContactGroup } from '../../../api/PUT/updateContactGroup'
import { toggleCsrfState } from '../../../slices/authSlice'
import { selectAllContacts } from '../../../slices/contactAddressSlice'
import { addGroup, editGroup, removeGroup } from '../../../slices/groupSlice'
import { contactGroupSerializer } from '../../../util/contactGroupSerializer'

export const useMutateContactGroup = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch()

  const allContactAddresses = useSelector(selectAllContacts)

  const createContactGroupMutation = useMutation(createContactGroup, {
    onSuccess: (data, variables) => {
      const { data: contactGroup } = data
      const { redirectPath } = variables
      dispatch(
        addGroup(contactGroupSerializer(contactGroup, allContactAddresses)),
      )
      navigate(redirectPath)
    },
    onError: (err: any) => {
      alert(`グループの作成に失敗しました`)
      if (err.response.data.detail === 'The CSRF token has expired.') {
        dispatch(toggleCsrfState())
      }
    },
  })

  const updateContactGroupMutation = useMutation(putContactGroup, {
    onSuccess: (data, variables) => {
      const { data: contactGroup } = data
      const { redirectPath } = variables
      dispatch(
        editGroup(contactGroupSerializer(contactGroup, allContactAddresses)),
      )
      navigate(redirectPath)
    },
    onError: (err: any) => {
      alert(`グループの更新に失敗しました`)
      if (err.response.data.detail === 'The CSRF token has expired.') {
        dispatch(toggleCsrfState())
      }
    },
  })

  const deleteContactGroupMutation = useMutation(delContactGroup, {
    onSuccess: (_, variables) => {
      const { id, redirectPath } = variables
      dispatch(removeGroup(id))
      navigate(redirectPath)
    },
    onError: (err: any) => {
      alert(`グループの削除に失敗しました`)
      if (err.response.data.detail === 'The CSRF token has expired.') {
        dispatch(toggleCsrfState())
      }
    },
  })

  return {
    createContactGroupMutation,
    updateContactGroupMutation,
    deleteContactGroupMutation,
  }
}
